<template>
  <div id="paymentSources">
    <template v-if="!addCardMode">
      <div class="font-semibold text-2xl">Select Your Payment Card:</div>
      <ul class="mt-8" v-if="cards">
        <li v-for="(card, index) in cards" :key="index">
          <CustomRadioButton
            class="mt-4"
            v-model="selectedCard"
            :name="'card' + card.id"
            :value="card.id"
          >
            <span class="ml-2">********{{ card.last4 }}</span>
          </CustomRadioButton>
        </li>
      </ul>
      <p v-else class="text-semibold mt-4 text-sm text-gray-600">No stored payment cards found</p>
    </template>

    <div class="flex mt-8 justify-around">
      <StyledButton
        v-if="!addCardMode"
        @click="showAddCardForm = true"
        type="secondary"
        >Add New Card</StyledButton
      >

      <StyledButton
        v-if="!addCardMode"
        @click="$emit('selected', selectedCard)"
        type="primary"
        class="ml-2"
        :disabled="!selectedCard"
        >Confirm</StyledButton
      >
      
    </div>

    <!-- Stripe -->
    <StripeCard
      v-if="addCardMode"
      @success="refreshCards"
      @canceled="showAddCardForm = false"
    />
  </div>
</template>

<script>
import CustomRadioButton from "@/components/CustomRadioButton";
import StripeCard from "@/components/common/payments/StripeCardComponent";
import StyledButton from "@/components/common/controls/StyledButton";


import ApiV1 from "@/api/api_v1.0";

export default {
  name: "PaymentSourcesComponent",
  components: { CustomRadioButton, StripeCard, StyledButton},
  data() {
    return {
      showAddCardForm: false,
      sources: null,
      selectedCard: null,
      cards: null
    };
  },

  created() {
    this.loadCards();
  },

  computed: {
    addCardMode() {
      return this.showAddCardForm || !this.isLoggedIn
    }
  },

  methods: {
    async loadCards() {
      if (!this.isLoggedIn) {
        return false;
      }
      
      const response = await ApiV1.getPaymentSources();
      let cards = [];

      response.data.map(account => {
        account.sources.map(source => {
          cards.push(source);
        });
      });

      if (cards.length > 0) {
        this.cards = cards;
      }
    },

    refreshCards() {
      
      this.loadCards();
      this.showAddCardForm = false;
    }
  }
};
</script>

<style></style>
